const PRINCIPLES = [
    { k: "01. LOCAL-FIRST WHERE PRACTICAL", v: "Compute on local devices wherever physically practical." },
    { k: "02. INTERNET ACCESS WHERE USEFUL", v: "Used strictly when useful, never as a hard operational barrier." },
    { k: "03. USER-CONTROLLED HARDWARE", v: "Hardware owned by the user. No subscription locks, no hostage devices." },
    { k: "04. NO SURVEILLANCE-BUSINESS-MODEL NONSENSE", v: "No advertising telemetry. No data monetisation. None." },
];

export default function LocalFirstSection() {
    return (
        <section id="local-first" className="py-20 border-b border-subtle bg-[#f2f4f6]" data-testid="local-first-section">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="p-8 sm:p-12 rounded-xl bg-white border border-subtle relative overflow-hidden">
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" />
                    <span className="font-mono text-xs text-cyan-600 tracking-widest block uppercase mb-2">
                        // Local-First Principles
                    </span>
                    <h2 className="font-display text-2xl sm:text-4xl font-bold text-slate-900 mb-4">
                        YOUR TOASTER DOESN&rsquo;T NEED THE CLOUD.
                    </h2>
                    <p className="text-slate-600 text-lg mb-3 leading-relaxed">Neither does everything else.</p>
                    <p className="text-slate-500 text-sm sm:text-base mb-8 leading-relaxed max-w-3xl">
                        Many Timbotic experiments deliberately favour local processing, local networks and
                        user-controlled hardware instead of unnecessary cloud dependency. This is the serious part.
                        It is also, not coincidentally, why most of it still works when the internet doesn&rsquo;t.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 font-mono text-xs text-slate-600">
                        {PRINCIPLES.map((p) => (
                            <div key={p.k} className="p-4 rounded bg-slate-100 border border-slate-200">
                                <span className="text-cyan-600 block mb-1">{p.k}</span>
                                {p.v}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
